import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-other-helpful-links';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-find-a-financial-advisor-${baseIdSuffix}`}
        linkUrl='/find-a-financial-advisor/'
        variant='primaryDeemphasize'>
        Find a Financial Advisor
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-legal-links-and-disclosures-${baseIdSuffix}`}
        linkUrl='/legal-information/'
        variant='primaryDeemphasize'>
        Legal Links and Disclosures
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-common-blood-test-and-risk-factors-${baseIdSuffix}`}
        linkUrl='/medical-information/'
        variant='primaryDeemphasize'>
        Common Blood Test and Risk Factors
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-directory-of-financial-advisors-and-representatives-${baseIdSuffix}`}
        linkUrl='/financial/advisors/'
        variant='primaryDeemphasize'>
        Directory of Financial Advisors and Representatives
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-directory-of-offices-${baseIdSuffix}`}
        linkUrl='/office/'
        variant='primaryDeemphasize'>
        Directory of Offices
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-latest-annual-report-${baseIdSuffix}`}
        linkUrl='/2022-annual-report/'
        variant='primaryDeemphasize'>
        Latest Annual Report
      </Link>
    ),
  },
];

export default () => (
  <Col
    medium={6}
    id='sitemap-helpful-links-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      Other Helpful Links
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </Col>

);
